import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { publicUrl } from "@/api/r2"; // usa l’helper già presente nella codebase

// ⬇️ FALLBACK: prima cerca in content/, poi in root
const CATALOG_CANDIDATES = ["content/catalog.json", "catalog.json"];

export default function ExtrasCard() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        let cat = null;
        let usedKey = null;

        // 🔧 prova i due percorsi in ordine
        for (const key of CATALOG_CANDIDATES) {
          const url = publicUrl(key) + "&ts=" + Date.now();
          const res = await fetch(url, { cache: "no-store", headers: { accept: "application/json" } });
          if (res.ok) {
            try {
              cat = await res.json();
              usedKey = key;
              break;
            } catch {
              // se il server mandasse un text/plain, riprova col prossimo candidato
            }
          }
        }

        if (!cat) throw new Error("catalog fetch failed (tried content/catalog.json, catalog.json)");

        const list = Array.isArray(cat?.items) ? cat.items : [];
        const visible = list.filter((it) => {
          const pub = it.published !== false; // default: visibile
          const isText = typeof it.type === "string" ? it.type.startsWith("text/") : true;
          return pub && isText && it.key;
        });

        if (!cancelled) setItems(visible);
        if (usedKey && !cancelled) console.debug("[ExtrasCard] catalog loaded:", usedKey, "items:", visible.length);
      } catch (e) {
        console.warn("[ExtrasCard] load error:", e);
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const listToShow = showAll ? items : items.slice(0, 3);

  return (
    <Card className="shadow-lg">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Contenuti Extra</CardTitle>
        <Button variant="outline" size="sm" onClick={() => setShowAll((s) => !s)}>
          {showAll ? "Mostra meno" : "Vedi tutti"} <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </CardHeader>
      <CardContent>
        {loading ? (
          <p className="text-sm text-gray-500">Caricamento…</p>
        ) : items.length === 0 ? (
          <p className="text-sm text-gray-500">Nessun contenuto disponibile.</p>
        ) : (
          <ul className="space-y-3">
            {listToShow.map((it) => (
              <li key={it.id || it.key} className="flex items-start justify-between" data-extra-item>
                <div>
                  <p className="font-medium text-gray-800">{it.title || it.id || it.key}</p>
                  {it.description && <p className="text-sm text-gray-600">{it.description}</p>}
                </div>
                <a
                  href={publicUrl(it.key)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 text-sm underline"
                >
                  Apri
                </a>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
